import React from 'react'
import PropTypes from 'prop-types'
import MarkdownRenderer from 'components/MarkdownRenderer'
import { Eyebrow } from 'components/Typography'
import { Container } from 'styles/sharedStyle'
import theme from 'styles/theme'

import {
  EventDetailWrapper,
  EventDetailHeader,
  EventDetailCopy,
  EventDetailMeta,
} from './EventDetail.style'

const EventDetail = ({
  eventRunStartDate,
  eventRunFinishDate,
  description,
  dateAndTimeHeading,
  dateAndTime,
  locationHeading,
  location,
}) => (
  <EventDetailWrapper
    as={Container}
    p={[`0 ${theme.space[4]}`, null, 0]}
    maxWidth={['none', null, 580]}
    textAlign="center">
    <EventDetailHeader>
      {`${eventRunStartDate} — ${eventRunFinishDate}`}
    </EventDetailHeader>

    <EventDetailCopy as={MarkdownRenderer} html={description} />

    {dateAndTime && (
      <EventDetailMeta>
        <Eyebrow>{dateAndTimeHeading}</Eyebrow>
        {dateAndTime}
      </EventDetailMeta>
    )}

    <EventDetailMeta>
      <Eyebrow>{locationHeading}</Eyebrow>
      {location}
    </EventDetailMeta>
  </EventDetailWrapper>
)

EventDetail.propTypes = {
  eventRunStartDate: PropTypes.string.isRequired,
  eventRunFinishDate: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  dateAndTimeHeading: PropTypes.string.isRequired,
  dateAndTime: PropTypes.string,
  locationHeading: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
}

EventDetail.defaultProps = {
  dateAndTime: null,
}

export default EventDetail
